import { router } from '@inertiajs/vue3'

export const navigateTo = (path: string) => {
  router.visit(path)
}
